import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';

import {API_GBG_CONFIG, API_REQUEST_STEP_GBG} from '../../../../../config/urls';
import {GbgConfigDto} from '@dto/gbg-config-dto.model';
import {RequestStepUpdateDto} from '@dto/requests/request-step-update.dto';
import {RequestStepGbgUpdateDto} from '@dto/requests/request-step-gbg-update.dto';
import {UrlService} from '@shared/services/url.service';

@Injectable({
  providedIn: 'root'
})
export class GbgRequestService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getConfig(): Observable<GbgConfigDto> {
    return this.http.get<GbgConfigDto>(API_GBG_CONFIG);
  }

  public save(requestId: string, requestStepId: number, journeyId: string): Observable<RequestStepUpdateDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUEST_STEP_GBG, requestId, String(requestStepId));
    const gbgUpdateDto: RequestStepGbgUpdateDto = {
      journeyId: journeyId
    };
    return this.http.post<RequestStepUpdateDto>(endpointUrl, gbgUpdateDto);
  }
}
